import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { preventFormDefault } from '@/modules/common/utils/preventFormDefault.ts';
import { useInvestorEditUpdateStatusMutation } from '@/modules/issuer-dashboard/queries/holder-create.tsx';
import { Button, ModalContentWrapper, TextInputField } from 'ui';
import { HandleInvestorEditsRequest, InvestorEditsStatus } from 'api';

const validationSchema = yup.object({
  description: yup.string().trim().required('Decline reason is required'),
});

const initialValues: HandleInvestorEditsRequest = {
  id: 0,
  status: InvestorEditsStatus.Rejected,
  description: '',
};

export interface HolderRejectEntityModalProps extends Pick<HandleInvestorEditsRequest, 'id'> {
  open: boolean;
  onClose: () => void;
}

export const HolderRejectEntityModal = ({ open, onClose, id }: HolderRejectEntityModalProps) => {
  const formik = useFormik<HandleInvestorEditsRequest>({
    initialValues: {
      ...initialValues,
      id,
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    validationSchema,
    onSubmit: async values => {
      await mutateAsyncChangeStatus(values);
    },
    enableReinitialize: true,
  });

  const { mutateAsync: mutateAsyncChangeStatus, isLoading: isLoadingChangeStatus } =
    useInvestorEditUpdateStatusMutation({
      setErrors: formik.setErrors,
      onSuccess: onClose,
    });

  const handleCloseModalWithResetForm = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <ModalContentWrapper open={open} title="Decline reason" onClose={handleCloseModalWithResetForm}>
      <FormikProvider value={formik}>
        <form className="w-full flex flex-col space-y-10" onSubmit={preventFormDefault}>
          <div className="w-full flex flex-col space-y-8">
            <TextInputField name="description" placeholder="Some reason..." textarea />
          </div>
          <Button
            onClick={formik.handleSubmit}
            loading={formik.isSubmitting || isLoadingChangeStatus}
            disabled={isLoadingChangeStatus}
          >
            Decline
          </Button>
        </form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
